<template>
  <div ><!--
    <v-tabs
      v-model="tab"
      fixed-tabs
      background-color="rgba(255,255,255,0.7)"

    >
    <v-tab v-for="menu in menuArray"
            :key="menu.name">-->
    <v-row class="d-flex justify-center">
      <v-menu
            bottom
            v-for="menu in menuArray"
            :key="menu.name"
            offset-y

        >
          <template v-slot:activator="{ on }">
            <v-btn
              text
              color="primary"
              class="align-self-center mr-4"
              v-on="on"
              x-large
              v-if="menu.pages"
            >
              {{menu.name}}
              <v-icon  right>mdi-menu-down</v-icon>
            </v-btn>
            <v-btn
              text
              color="primary"
              class="align-self-center mr-4"
              x-large
              v-if="!menu.pages"
              :disabled="menu.disabled"
              @click="selectTab = menu.tab"
            >
              {{menu.name}}
            </v-btn>

          </template>

          <v-list class="grey lighten-3">
            <v-list-item
              v-for="page in menu.pages"
              :key="page.name"
              :disabled="page.disabled"
              @click="selectTab = page.tab"
            >
              {{ page.name }}
            </v-list-item>
          </v-list>
      </v-menu>
    </v-row>

    <!--</v-tab>
    <v-tab :disabled="items[8].disabled">
      {{items[8].tab}}
    </v-tab>

      <v-tab :disabled="item.disabled" v-for="(item, index) of items" :key="index">
        {{item.tab}}
      </v-tab>
    </v-tabs>-->
  <div>
      <Initialize v-if="selectTab == 0" @disableTab="disableTab" @enableTab="enableTab($event)" />
      <Detect v-if="selectTab == 1" ></Detect>
      <ListKeyStore v-if="selectTab == 2" @enableTab="enableTab($event)" @setKeystore="keyStoreIds= $event" />
      <KeystoreInfo v-if="selectTab == 3" @enableTab="enableTab($event)" :keyStoreIds="keyStoreIds" @setKeyStoreId="keyStoreId = $event" @setKeyStoreInfo="keyStoreInfo = $event"/>
      <GenerateCSR v-if="selectTab == 4" @enableTab="enableTab($event)" :keyStoreIds="keyStoreIds" :keyStoreInfo="keyStoreInfo" :keyStoreId="keyStoreId" @setConfig="config = $event"  @setCSR="setCSR($event)" :data="data"/>
      <GenerateCertificate v-if="selectTab == 5" @enableTab="enableTab($event)" @setPKCS7="setPKCS7($event)" :csr="csr"/>
      <InstallCertificate v-if="selectTab == 6" @enableTab="enableTab($event)" :config="config" :data="data" :pkcs7="pkcs7"/>
      <CertificateList v-if="selectTab == 7" @enableTab="enableTab($event)" @setCertificateList="setListCertificates($event)"/>
      <Sign v-if="selectTab == 8" :certList="certList"/>
      <SignServer v-if="selectTab == 18"/>
      <TestGui v-if="selectTab == 9"/>
      <Diagnosis v-if="selectTab == 10" @disableTab="disableTab" @enableTab="enableTab($event)" />
      <ListProfile v-if="selectTab == 11" @enableTab="enableTab($event)" @setListProfiles="setListProfiles($event)"/>
      <ImportCertificate v-if="selectTab == 12" @enableTab="enableTab($event)" :config="config" :data="data" :certificateSelector="{ keystoreId: 'PFX', profileName: '-Select-' }"/>
      <InitializeProfile v-if="selectTab == 13" @enableTab="enableTab($event)" :keyStoreIds="keyStoreIds" :keyStoreInfo="keyStoreInfo" :keyStoreId="keyStoreId" :data="data"/>
      <ServerConfigManager v-if="selectTab == 14" @enableTab="enableTab($event)" :config="config" :data="data" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)"/>
      <CreateCredential v-if="selectTab == 15" @enableTab="enableTab($event)" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)"/>
      <AddSecondFactors v-if="selectTab == 16" @enableTab="enableTab($event)" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)"/>
      <AddCertificate v-if="selectTab == 17" @enableTab="enableTab($event)" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)" @setCSR="setCSR($event)" :pkcs7="pkcs7" :csr="csr"/>
  </div>

    <Snackbar />
  </div>
</template>
<script>
import GenerateCSR from './components/GenerateCSR';
import InstallCertificate from './components/InstallCertificate';
import ImportCertificate from './components/ImportCertificate';
import GenerateCertificate from './components/GenerateCertificate';
import CertificateList from './components/ListCertificates';
import ListKeyStore from './components/ListKeyStores';
import ListProfile from './components/ListProfiles';
import KeystoreInfo from './components/KeystoreInfo';
import InitializeProfile from './components/InitializeProfile';
import Sign from './components/GenerateSignature.vue';
import SignServer from './components/SignServer.vue';
//import Migrate from './Migrate';
import Initialize from './components/InitializeAlisonDesktop.vue';
import Detect from './components/DetectAlisonDesktop.vue';
import Snackbar from './components/SnackBar.vue';
import TestGui from './components/TestGui';
import Diagnosis from './components/DiagAlisonDesktop.vue';

import * as testingDatas from '@/datas/testingDatas.js';
import { mapMutations } from 'vuex'
import ServerConfigManager from './components/ServerConfigManager';
import CreateCredential from './components/CreateCredential';
import AddSecondFactors from './components/AddSecondFactors';
import AddCertificate from './components/AddCertificate';
//Vue.loadScript("./thirdparty/jsrsasign-latest-all-min.js")
  export default {
  components: {
    Snackbar,
    GenerateCSR,
    ImportCertificate,
    InstallCertificate,
    GenerateCertificate,
    CertificateList,
    ListKeyStore,
    Sign,
    SignServer,
    KeystoreInfo,
    Initialize,
    InitializeProfile,
    Detect,
    TestGui,
    Diagnosis,
    ListProfile,
    ServerConfigManager,
    AddSecondFactors,
    CreateCredential,
    AddCertificate
},
    data () {
      return {
        tab: null,
        config:null,
        serverConfig: null,
        alisonSdk: null,
        data: null,
        csr: null,
        pkcs7: null,
        selectTab:0,
        keyStoreIds: [],
        keyStoreInfo: [],
        profiles: [],
        keyStoreId: '',
        certList: [],
        menuArray: [
          {
            name: 'Library',
            pages: [
              {name: 'Initialize', tab: 0, disabled: false},
              {name: 'Status', tab: 1, disabled: false},
              {name: 'Diagnosis', tab: 10, disabled: false},
            ],
          },
          {
            name: 'KeyStore',
            pages: [
              {name: 'List enabled KeyStores', tab: 2, disabled: true},
              {name: 'Get KeyStore information', tab: 3, disabled: true},
            ],
          },
          {
            name: 'Profile',
            pages: [
              {name: 'List available Profiles', tab: 11, disabled: true},
              {name: 'Initialize Profile', tab: 13, disabled: true},
            ],
          },
          {
            name: 'Certificate',
            pages: [
              {name: 'List all Certificates', tab: 7, disabled: true},
              {name: 'Generate CSR', tab: 4, disabled: true},
              {name: 'Generate Certificate', tab: 5, disabled: false},
              {name: 'Install Certificate', tab: 6, disabled: true},
              {name: 'Import Certificate', tab: 12, disabled: true},
            ],
          },
          {
            name: 'Sign',
            pages: [
              {name: 'Sign Server', tab: 18, disabled: true},
              {name: 'Sign Desktop', tab: 8, disabled: true},
            ],
          },
          {
            name: 'GUI',
            tab: 9,
            disabled: false
          },
          {
            name: 'Alison Server',
            pages: [
              {name: 'Config Manager', tab: 14, disabled: false},
              {name: 'Create Credential', tab: 15, disabled: false},
              {name: 'Add second factors', tab: 16, disabled: false},
              {name: 'Add certificate', tab: 17, disabled: false},
            ],
          },
        ],
        items: [
          { tab: 'Initialize', content: 'Tab 0 Content', disabled: false },
          { tab: 'Detect', content: 'Tab 1 Content', disabled: false },
          { tab: 'List enabled KeyStores', content: 'Tab 2 Content', disabled: true },
          { tab: 'Get KeyStore infornation', content: 'Tab 3 Content', disabled: true },
          { tab: 'Generate CSR', content: 'Tab 4 Content', disabled: true },
          { tab: 'Generate Certificate', content: 'Tab 5 Content', disabled: false },
          { tab: 'Install Certificate', content: 'Tab 6 Content', disabled: true },
          { tab: 'Import Certificate', content: 'Tab 12 Content', disabled: true },
          { tab: 'List all Certificates', content: 'Tab 7 Content', disabled: true },
          { tab: 'List available Profiles', content: 'Tab 11 Content', disabled: true },
          { tab: 'Sign', content: 'Tab 8 Content', disabled: true },
          { tab: 'Test GUI', content: 'Tab 9 Content', disabled: true },
          { tab: 'Config Manager', content: 'Tab 13 Content', disabled: false },
          { tab: 'Create Credential', content: 'Tab 14 Content', disabled: false },
          { tab: 'Add second factors', content: 'Tab 15 Content', disabled: false },
          { tab: 'Add certificate', content: 'Tab 16 Content', disabled: false },
          //{ tab: 'Migrate', content: 'Tab 7 Content', disabled: true },
        ],
      }
    },
    created(){
      this.data = testingDatas
      var URLactual = window.location.search;
      console.log(URLactual)
      var url = URLactual.replace("?", ''); // remove the ?
      console.log("url:", url)
      switch (url) {
        case "tab=Diagnosis":
        case "tab=diagnosis":
        case "Diagnosis":
          this.selectTab = 10
          break;
        case "tab=Detect":
        case "tab=detect":
        case "Detect":
          this.selectTab = 1
          break;
        default:
          break;
      }
    },
    watch: {
      /*selectTab(value, oldValue){
        console.log("value:", value)
        console.log("oldValue:", oldValue)
        if (value !== 10 && oldValue === 10 && window.location.pathname === "/diagnosis") window.location.pathname = "/"
      }*/
    },
    methods: {
      setServerConfig(config) {
        this.serverConfig = { ...this.serverConfig,  ...config };
      },
      setCSR(csr){
        this.csr = csr;
      },
      setPKCS7(pkcs7){
        this.pkcs7 = pkcs7;
      },
      disableTab(){
        this.menuArray.forEach(menu => {
            if(menu.name != 'Library' && menu.pages) {
              menu.pages.forEach(page => {
                page.disabled = true
              })
            }else{
              if(menu.name == 'Sign') {
                menu.disabled = true
              }
            }
          })
      },
      enableTab(values){
        values.forEach(tabToChange => {
          this.menuArray.forEach(menu => {
            if(menu.pages) {
              menu.pages.forEach(page => {
                if(page.name === tabToChange) page.disabled = false
              })
            }else{
              if(tabToChange == 'Sign') {
                menu.disabled = false
              }
            }
          })
        })
      },
      setListProfiles(_profiles) {
        this.profiles=_profiles
      },
      setListCertificates(cert) {
        this.certList=cert
      }
    }
  }
</script>
<style scoped lang='css'>
.alison-lib > .theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent;
}
.alison-lib-tabs-items > .theme--light.v-sheet{
  background-color: transparent;

}
.theme--light.v-tabs-items {
    background-color: transparent !important;
}
</style>
